export default {
    auth: {
        IDPURL: "https://cloud-services.its.uq.edu.au/sso/saml2/idp/SSOService.php",
        spIdentity: "aws-tokenmachine",
        region: "ap-southeast-2"
    },
    app: {
        invokeURL: "https://tokenmachine.cloud-services.its.uq.edu.au"
    }
};